export default __webpack_public_path__ + "static/media/netflix.258bec62.svg";